import { SliceProps } from "@/Slice/index"
import { GRichText } from "@/components"
import { isFilled } from "@prismicio/helpers"

export const Paragraphs = ({ slice: { items }, className }: SliceProps<"paragraphs">) => (
    <div className={className}>
        {items
            .filter((i) => isFilled.richText(i.paragraph))
            .map((item, index) => (
                <div key={index} className="mb-5 text-base">
                    <GRichText field={item.paragraph} paragraphClass="mb-2.5 text-sm" />
                </div>
            ))}
    </div>
)
